























































import { APInotLoggedIn } from '@/plugins/axios';
import { Component, Vue, Ref } from 'vue-property-decorator';

@Component({})
export default class RegisterForm extends Vue {
  @Ref('registerForm') registerForm!: Vue;

  validRegisterForm = true;
  registered = false;
  error = false;
  errorMessage = '';

  registerData = {
    password: '',
    passwordConfirmation: '',
  };

  registerDataValidations = {
    password: [
      (v: string) => {
        if (!v.length) {
          return 'Password is required';
        } else if (v.length < 6) {
          return 'Password have to be longer then 5 characters';
        } else {
          return true;
        }
      },
    ],
    passwordConfirmation: [
      (v: string) => !!v || 'Password Confirmation is required',
      (v: string) => v === this.registerData.password || 'Passwords do not match',
    ],
  };

  async submitRegister() {
    /* eslint-disable @typescript-eslint/camelcase */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.registerForm as any).validate()) {
      // TODO: Move to action, set axios
      try {
        await APInotLoggedIn.post('/api/misc/updatepwd/', {
          uuid: this.$route.params.uuid,
          pwd: this.registerData.password,
        });

        this.registered = true;
      } catch (e) {
        const status = e.response.status;
        this.error = true;
        if (status === 400) {
          this.errorMessage = 'Password Reset Request has been already resolved';
        } else {
          this.errorMessage = 'Something went wrong, please try again';
        }
      }
    }
    /* eslint-enable @typescript-eslint/camelcase */
  }

  passwordReqValid = true;

  async mounted() {
    try {
      await APInotLoggedIn.post('/api/misc/verifypwdrstreq/', {
        uuid: this.$route.params.uuid,
      });
      this.passwordReqValid = true;
    } catch {
      this.passwordReqValid = false;
    }
  }
}
